import { JobApplicationStatus } from '../../../domain/types';
import { DEFAULT_PAGINATION_SIZE } from '../../../utils/querystring/querystring';
import {
  PaginatedResult, PaginationParams, serializePagination,
} from '../../pagination';
import { API_HR_PATH, getClient } from '../api';
import { JobApplication } from '../dtos';
import { UpdateProviderFunction } from '../types';
import { serializeParams } from '../utils/serializer';

export interface JobApplicationFilters {
  applicantId?: number | number[],
  status?: JobApplicationStatus | JobApplicationStatus[],
  jobPositionId?: string | string[],
  province?: string | string[],
}

export async function getJobApplication(jobApplicationId: string): Promise<JobApplication> {
  const client = await getClient();
  const { data } = await client.get<JobApplication>(`${API_HR_PATH}/job-applications/${jobApplicationId}`);
  return data;
}

export async function getJobApplications(filters: JobApplicationFilters = {}, pagination: PaginationParams = { size: DEFAULT_PAGINATION_SIZE }): Promise<PaginatedResult<JobApplication>> {
  const client = await getClient();
  const { data } = await client.get<PaginatedResult<JobApplication>>(`${API_HR_PATH}/job-applications`,
    {
      params: {
        ...serializeParams(filters),
        ...serializePagination(pagination),
      },
    });
  return data;
}

export async function createJobApplication(jobApplication: JobApplication): Promise<JobApplication> {
  const client = await getClient();
  const { data } = await client.post<JobApplication>(`${API_HR_PATH}/job-applications`, jobApplication);
  return data;
}

export const updateJobApplication: UpdateProviderFunction<JobApplication> = async (id: string, jobApplication: JobApplication) => {
  const client = await getClient();
  const { data } = await client.put<JobApplication & { id: NonNullable<JobApplication['id']> }>(`${API_HR_PATH}/job-applications/${id}`, jobApplication);
  return data;
};
